module.exports = __webpack_public_path__ + "static/media/Hellen Ward, Co-Founder, Richard Ward Hair & Metrospa.bdb91e13.png";